import React from 'react';
import ThemeConstants from '../../config/theme/theme_constants';
import { useTranslation } from '../../i18n/useTranslation';
import DocumentBackButton from './document_back_button';

const theme = ThemeConstants();

type PolicyBlock = { p: string } | { h: string } | { label: string } | { list: string[] };

interface PolicySection {
  title: string;
  blocks: PolicyBlock[];
}

const PCUvibes: React.FC = () => {
  const { t } = useTranslation();
  const sections = t('privacy.sections', { returnObjects: true }) as PolicySection[];

  return (
    <div className='flex flex-col min-h-dvh w-full relative' style={{ background: `linear-gradient(90deg, ${theme.UvibesPinkGradient} 0%, ${theme.UvibesOrangeGradient} 75%)` }}>
      <DocumentBackButton />
      <Header />
      <div className="rounded-t-[30px] bg-white px-4 py-8 w-full space-y-12">
        {Array.isArray(sections) && sections.map((section, index) => (
          <Section key={index} number={index + 1} section={section} />
        ))}
        <FooterPolitique />
      </div>
    </div>
  );
};

const Header: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="text-white p-12 text-center">
      <div className="space-y-6">
        <div className="text-5xl">🔒</div>
        <h1 className="text-4xl font-bold leading-tight">
          {t('privacy.title')}
        </h1>
        <p className="text-xl text-white/90">
          {t('privacy.subtitle')}
        </p>
        <div className="w-24 h-1 bg-white/60 mx-auto rounded-full"></div>
      </div>
    </div>
  );
};

const Section: React.FC<{ number: number; section: PolicySection }> = ({ number, section }) => {
  return (
    <section className="space-y-6">
      <ArticleTitlePolitique number={String(number)} title={section.title} />
      <div className="space-y-4 ml-6 text-gray-700 leading-relaxed">
        {section.blocks.map((block, index) => <Block key={index} block={block} />)}
      </div>
    </section>
  );
};

const Block: React.FC<{ block: PolicyBlock }> = ({ block }) => {
  if ('h' in block) {
    return <h4 className="text-lg font-semibold text-gray-800 pt-2">{block.h}</h4>;
  }
  if ('label' in block) {
    return <p className="font-semibold text-gray-800">{block.label}</p>;
  }
  if ('list' in block) {
    return (
      <div className="p-4 rounded-lg border-l-4" style={{ borderColor: theme.UvibesBlue, backgroundColor: theme.UvibesBlue + '20' }}>
        <ul className="space-y-2">
          {block.list.map((item, index) => (
            <li key={index} className="flex items-start gap-2">
              <span className="text-gray-500">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return <p>{block.p}</p>;
};

const FooterPolitique: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="py-8 rounded-lg text-center" style={{ backgroundColor: theme.UvibesGray + '20' }}>
      <div className="text-gray-600 text-sm">
        <p>{t('legal.signed')}</p>
      </div>
    </div>
  );
};

const ArticleTitlePolitique: React.FC<{ number: string; title: string }> = ({ number, title }) => {
  return (
    <div className="border-l-4 pl-4" style={{ borderColor: theme.UvibesPink }}>
      <h3 className="text-xl font-semibold text-gray-800">
        <span style={{ color: theme.UvibesPink }}>{number}.</span> {title}
      </h3>
    </div>
  );
};

export default PCUvibes;
